<div class="header-wrapper grid grid-cols-12 m-0">
  <form
    class="form-inline search-full"
    [class.open]="layoutService.isSearchOpen"
  >
    <app-search></app-search>
  </form>

  <div class="header-logo-wrapper hidden col-auto p-0 lg:block">
    <app-header-logo
      [icon]="'align-center'"
      [type]="'header'"
    ></app-header-logo>
  </div>

  <div
    class="left-header col-span-5 xxl:col-span-6 xl:col-span-5 lg:col-span-4 md:col-span-3"
  ></div>

  <div
    class="nav-right col-span-7 xxl:col-span-6 xl:col-span-7 md:col-span-11 float-right right-header p-0 ms-auto"
  >
    <ul class="nav-menus">
      <li class="profile-nav onhover-dropdown pe-0 py-0">
        <app-profile></app-profile>
      </li>
    </ul>
  </div>
</div>
